import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ProfileService } from '../auth/profile/profile.service';

@Component({
  template: ''
})
export class NotFoundRedirectComponent implements OnInit {
  constructor(private router: Router, private profileService: ProfileService) {}

  ngOnInit() {
    this.profileService.load().subscribe({
      next: () => {
        if (this.profileService.isOnboarding()) {
          this.router.navigateByUrl('/setup/setupwizard/step1');
        } else {
          this.router.navigateByUrl('/bots');
        }
      },
      error: (error) => {
        console.error('Error loading profile:', error);
        // If profile loading fails, redirect to onboarding as a fallback for new users
        this.router.navigateByUrl('/setup/setupwizard/step1');
      }
    });
  }
}
